const words = [
  'Film',
  'Sound',
  'Aerial',
  'Digital',
  'Design',
  'Live',
  'Strategy',
  'Story'
];

function Marquee() {
  const items = [...words, ...words];

  return (
    <section className="marquee" aria-label="Our creative disciplines">
      <div className="marquee-track">
        {items.map((word, index) => (
          <span key={`${word}-${index}`}>
            {word}<i>✦</i>
          </span>
        ))}
      </div>
    </section>
  );
}

export default Marquee;